export class GameAvalancheReelsEvents {
	public static readonly WIN_HIGHLIGHTING_FINISHED: string = 'GameAvalancheReelEvents::WIN_HIGHLIGHTING_FINISHED';
	public static readonly WIN_HIGHLIGHTING_STARTED: string = 'GameAvalancheReelEvents::WIN_HIGHLIGHTING_STARTED';
	public static readonly WIN_HIGHLIGHTING_WINLINE: string = 'GameAvalancheReelEvents::WIN_HIGHLIGHTING_WINLINE';
	public static readonly WIN_SYMBOLS_EXPLOSION_STARTED: string = 'GameAvalancheReelEvents::WIN_SYMBOLS_EXPLOSION_STARTED';
	public static readonly SYMBOL_PASSED_THROUGHT_LINE: string = 'GameAvalancheReelEvents::SYMBOL_PASSED_THROUGHT_LINE';
	public static readonly SCATTER_ATTENTION_TRIGGERED: string = 'GameAvalancheReelEvents::SCATTER_ATTENTION_TRIGGERED';
	public static readonly RESPIN_ATTENTION_TRIGGERED: string = 'GameAvalancheReelEvents::RESPIN_ATTENTION_TRIGGERED';
	public static readonly FILLING_VOIDS_STARTED: string = 'GameAvalancheReelEvents::FILLING_VOIDS_STARTED';
}



// WEBPACK FOOTER //
// ./src/avalanche/GameAvalancheReelsEvents.ts